// This file is part of MinIO Design System
// Copyright (c) 2024 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import React, { FC, SVGProps } from "react";

import LogoBase from "../LogoBase/LogoBase";
import { LogoBaseProps } from "../LogoBase/LogoBase.types";

const AIStorHorizontal: FC<SVGProps<any> & LogoBaseProps> = ({
  inverse,
  onClick,
}) => {
  return (
    <LogoBase viewBox="0 0 576.2 51" inverse={inverse} onClick={onClick}>
      <g>
        <g id="Layer_1">
          <g id="Layer_1-2" data-name="Layer_1">
            <g id="Layer_1-2">
              <g>
                <path className={"minioSection"} d="M312.6,49.1h0Z" />
                <path
                  className={"minioSection"}
                  d="M82.3,26.9v20.5c0,1.1-.3,1.3-1.4,1.3h-13.5c-.9,0-1.2-.2-1.2-1.2v-18.5c0-2.1-1.1-2.8-2.9-1.7l-18,10.5c-2.4,1.5-4.7,1.4-7.1,0-5.6-3.5-11.3-6.9-17-10.4-.6-.4-1.3-.8-2.1-.4-.8.5-.9,1.2-.9,2v18.5c0,.9-.3,1.1-1.1,1.1H3.3c-.9,0-1.1-.3-1.1-1.1V6.7c0-1.9.5-3.6,2.3-4.5,1.8-1,3.5-.6,5.2.4,10.3,6.3,20.6,12.6,30.9,18.9,1.2.7,2,.7,3.1,0,10.4-6.4,20.8-12.7,31.1-19,2.7-1.6,5.7-.8,6.9,1.9.3.7.3,1.4.3,2.1v20.4s.3,0,.3,0Z"
                />
                <path
                  className={"minioSection"}
                  d="M123.3,26.8V6.4c0-3.8,3.4-5.9,6.8-4.1,13.7,7.3,27.4,14.6,41.1,21.9.4.2.8.5,1.4.5,1,0,1.5-.7,1.5-2V2.8c0-.8.1-1.1,1-1.1h14.2c.8,0,1,.2,1,1v41.3c0,3.8-3.5,5.9-6.9,4-12.8-6.8-25.6-13.5-38.4-20.3-1-.5-2-1.1-3-1.6-1.7-.9-2.7-.3-2.7,1.6v19.6c0,1.1-.3,1.4-1.4,1.3h-13.8c-.8,0-1-.2-1-1v-20.8h.2Z"
                />
                <path
                  className={"minioSection"}
                  d="M252.7,49.6c-6.6,0-13.6-1.1-20.1-4.4-5.7-2.9-10.1-7.1-12-13.3-3.1-10,.7-19.8,9.9-25.4,5.1-3.1,10.8-4.7,16.7-5.3,7.3-.8,14.5-.3,21.6,1.9,5.8,1.9,10.9,4.8,14.5,9.8,7,9.7,4.4,23.4-5.8,30.3-4.8,3.3-10.2,5-15.9,5.8-2.7.4-5.5.6-8.9.6ZM253.4,43.3c1.8,0,3.7,0,5.6-.3,5.1-.7,9.9-2,14-5.1,7.4-5.5,8.6-15.8,2.6-22.8-2.6-3.1-6.1-4.9-9.9-6.1-6.4-2-12.9-2.3-19.5-1.3-4.4.7-8.7,2-12.3,4.8-5.4,4.1-7.5,9.5-6.2,16.1.9,5,4,8.4,8.3,10.8,5.4,3,11.2,3.9,17.4,3.9h0Z"
                />
                <path
                  className={"minioSection"}
                  d="M94.8,25.1V2.6c0-.9.3-1.1,1.1-1.1h14.1c.7,0,.9.1.9.9v45.5c0,.7-.2.9-.9.9h-14.2c-.9,0-1-.3-1-1.1v-22.6Z"
                />
                <path
                  className={"minioSection"}
                  d="M210.3,25.2v22.4c0,1-.3,1.2-1.2,1.2h-5.3c-.9,0-1.2-.2-1.2-1.2V10.6c0-12.4,0-5.4,0-8.1s.3-1.2,1.2-1.1h5.5c.8,0,1,.2,1,1v22.7h0Z"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              className={"minioSection"}
              d="M369.8,24.1v-4.7c0-1.1.9-2,2-2h11.3c2.2,0,2.8,3.1.8,3.9l-11.3,4.7c-1.3.5-2.8-.4-2.8-1.9"
            />
            <path
              className={"minioApplicationName"}
              d="M341.9,48.6h10.4l-16.8-31h-13.1l-17,31h12.5l14.5-6c2-.8,1.4-3.7-.7-3.7h-11.1l8.3-16.4s12.9,26.2,12.9,26.2Z"
            />
            <path
              className={"minioApplicationName"}
              d="M423.1,20.9l-2.9,6c-4.5-2.4-10.4-3.6-15.6-3.6s-8.2,1-8.2,2.7,3.8,2.7,11.2,3.2c10.3.8,16.8,3.1,16.8,9.3s-7.3,10.6-19.3,10.6-14.7-2.1-19-5.7l4.4-5.2c3.3,2.8,9.5,4.4,15.4,4.4s9.3-1.4,9.3-3.3-4.1-2.8-12.1-3.5c-8.7-.7-15.9-2.9-15.9-9.1s6.7-9.9,18.1-9.9,12.7,1.2,17.8,4"
            />
            <polygon
              className={"minioApplicationName"}
              points="442.3 48.6 442.3 23.9 426.8 23.9 426.8 17.5 466.6 17.5 466.6 23.9 451.1 23.9 451.1 48.6 442.3 48.6"
            />
            <path
              className={"minioApplicationName"}
              d="M513.5,33c0,9.8-9.2,16.2-22.8,16.2s-22.7-6.4-22.7-16.2,9.4-16.1,22.7-16.1,22.8,6.1,22.8,16.1M477.3,32.9c0,6,5.4,9.9,13.4,9.9s13.3-3.8,13.3-9.9-5.4-9.6-13.3-9.6-13.4,3.1-13.4,9.6"
            />
            <path
              className={"minioApplicationName"}
              d="M557.3,48.6l-13.2-11.6c7.6,0,12.5-4.7,12.5-9.7s-5.1-9.7-16.6-9.7h-20.4v31.1h8.9v-24.8h10.3c5.6,0,8.5,1.2,8.5,4.1s-2.1,4.6-8,4.6h-5c-1.2,0-1.9.3-2.2,1.1-.3.7,0,1.4,1.2,2.7l11.9,12.3h12.3Z"
            />
            <rect x="355.8" y="17.5" width="8.8" height="31" />
          </g>
        </g>
      </g>
    </LogoBase>
  );
};

export default AIStorHorizontal;
